import CommonContainer from "../Container/CommonContainer"
import { useForm, Controller } from "react-hook-form";
import { useState, useRef, useEffect } from "react";
import MultiSelect from 'multiselect-react-dropdown';
import ReactDatePicker from 'react-datepicker';
import { Calendar } from "lucide-react";
import * as NotificationService from '../../Services/Notification/NotificationService'
import toast from "react-hot-toast";
import { allowedTypes } from "../../Common/CommonVariables";
import { FaCheckCircle, FaTimesCircle, FaPen, FaSearch } from "react-icons/fa";
import CommonPagination from "../../Common/CommonPagination";
import "./NotificationComponent.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const NotificationComponent = () => {
    const [addNotificationModal, setAddNotificationModal] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset, control, setValue, watch, setError, clearErrors } = useForm();
    const fileInputRef = useRef(null);
    const endDateRef = useRef(null);
    const startDateRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [activeTab, setActiveTab] = useState('editor');

    const isForAll = watch("Is_For_All", false);
    // const [description, setDescription] = useState('');
    const [descriptionErrors, setDescriptionErrors] = useState({});

    const [partnerList, setPartnerList] = useState([]);
    const [selectedPartnerCodes, setSelectedPartnerCodes] = useState([]);
    const [notificationList, setNotificationList] = useState([]);
    const [filteredNotificationList, setFilteredNotificationList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedNotification, setSelectedNotification] = useState([]);

    const indexOfLastNotification = currentPage * itemsPerPage;
    const indexOfFirstNotification = indexOfLastNotification - itemsPerPage;
    const currentNotifications = filteredNotificationList.slice(indexOfFirstNotification, indexOfLastNotification);

    const fetchActivePartnerList = () => {
        NotificationService.GetActivePartnerList()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setPartnerList(
                        data.Data
                            .filter(p => p.Partner_Name != null)
                            .map(p => ({ ...p, Partner_Display: `${p.Partner_Name} - ${p.Partner_Code}` }))
                    );
                }
                else {
                    setPartnerList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."));
    }

    const fetchActiveNotificationList = () => {
        NotificationService.GetActiveNotificationList()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setNotificationList(data.Data);
                    setFilteredNotificationList(data.Data);
                }
                else {
                    setNotificationList([]);
                    setFilteredNotificationList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."));
    }

    const handleSearch = (searchValue) => {
        setSearchTerm(searchValue);
        setCurrentPage(1); // Reset to first page when searching

        if (!searchValue.trim()) {
            setFilteredNotificationList(notificationList);
            return;
        }

        const searchLower = searchValue.toLowerCase();
        const filtered = notificationList.filter(notification =>
            notification.Title?.toLowerCase().includes(searchLower) ||
            notification.Notification_Creteria?.toLowerCase().includes(searchLower)
        );

        setFilteredNotificationList(filtered);
    };

    const handlePartnerSelect = (selectedItem) => {
        setSelectedPartnerCodes((prev) => [
            ...prev,
            selectedItem?.Partner_Code,
        ]);
 
        ////console.log("selected partner code is", selectedItem.Partner_Code, selectedPartnerCodes);
    }

    const handlePartnerRemove = (removedItem) => {
        setSelectedPartnerCodes((prev) =>
            prev.filter(code => code !== removedItem.Partner_Code)
        );

        // //console.log("removed partner code is", removedItem.Partner_Code, selectedPartnerCodes);
    };

    const handleMainFileUpload = (event) => {
        //debugger;
        const file = event.target.files[0];
        const maxFileSize = 5 * 1024 * 1024; // 5MB
        if (file) {
            if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
                toast.error('File is either unsupported or exceeds the 5MB limit.');
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
                return;
            }

            // You can add logic here to determine which section/document to update
            setSelectedFiles(file);
        }
    };

    useEffect(() => {
        fetchActivePartnerList();
        fetchActiveNotificationList();
    }, [])

    const handleModalClose = () => {
        reset();
        setAddNotificationModal(false);
        setSelectedNotification([]);
        setSelectedPartnerCodes([]);
    }

    const CreateNewNotification = (notificationDet) => {
        notificationDet.Partner_Codes = selectedPartnerCodes
        NotificationService.CreateNotification(notificationDet)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    toast.success("Notification saved successfully!");
                    handleModalClose();
                    fetchActiveNotificationList();
                } else {
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => toast.error("Something went wrong during creation."))
            .finally(() => { });
    }

    const UpdateNotification = (notificationDet) => {
        notificationDet.Partner_Codes = selectedPartnerCodes
        NotificationService.UpdateNotification(notificationDet)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    toast.success("Notification saved successfully!");
                    handleModalClose();
                    fetchActiveNotificationList();
                    //console.log(data);
                } else {
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => toast.error("Something went wrong during creation."))
            .finally(() => { });
    }

    const onSubmit = (notificationDet) => {
        //debugger;

        // Clear previous if valid
        if (notificationDet.Is_marquee_notification == false && notificationDet.Is_popup_notification == false) {
            setError("notification_check", {
                type: "manual",
                message: "Select if the notification Is Marquee up or Is Popup",
            });
            return;
        }

        if (selectedNotification.Id != null) {
            notificationDet.Id = selectedNotification.Id
            //with document
            if (notificationDet.Document_File != null && notificationDet.Document_File.length > 0) {
                const formData = new FormData();
                formData.append('file', selectedFiles);

                NotificationService.AddNewDocument(formData)
                    .then(({ data }) => {
                        if (data.IsSuccess) {
                            notificationDet.Notification_Image_Url = data.Data;
                            UpdateNotification(notificationDet);
                        }
                        else {
                            toast.error(data.ResponseMessage);
                        }
                    })
                    .catch(() => toast.error("Something went wrong during creation."))
                    .finally(() => { });
            }
            //without document
            else {
                UpdateNotification(notificationDet);
            }
        }
        else {
            //with document
            if (notificationDet.Document_File != null && notificationDet.Document_File.length > 0) {
                const formData = new FormData();
                formData.append('file', selectedFiles);

                NotificationService.AddNewDocument(formData)
                    .then(({ data }) => {
                        if (data.IsSuccess) {
                            notificationDet.Notification_Image_Url = data.Data;
                            CreateNewNotification(notificationDet);
                        } else {
                            toast.error(data.ResponseMessage);
                        }
                    })
                    .catch(() => toast.error("Something went wrong during creation."))
                    .finally(() => { });
            }
            //without document
            else {
                CreateNewNotification(notificationDet);
            }
        }
    }

    const handleViewNotification_byId = (notification_id) => {
        const selectedItem = notificationList.find(item => item.Id === notification_id);
        if (selectedItem != null) {
            setSelectedNotification(selectedItem);
            setAddNotificationModal(true);
        }
        else {
            setSelectedNotification({});
        }
    }

    useEffect(() => {
        if (selectedNotification && partnerList.length > 0) {
            // Set partners with proper matching
            if (selectedNotification.Partner_Codes?.length > 0) {
                const defaultPartners = partnerList.filter(partner =>
                    selectedNotification.Partner_Codes.includes(partner.Partner_Code)
                );
                setValue('partners', defaultPartners);
                setSelectedPartnerCodes(selectedNotification.Partner_Codes);
            }
        }
    }, [selectedNotification, partnerList, setValue]);

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // const modules = {
    //     toolbar: [
    //         [{ 'header': [1, 2, 3, false] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         // ['link', 'image'],
    //         ['clean']
    //     ],
    // };

    const modules = {
    toolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['clean']
    ],
    };

    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike',
        'list', 'bullet'
    ];

    const decodeHTML = (htmlString) => {
        if (!htmlString) return '';

        // First decode HTML entities
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const decodedString = tempDiv.textContent || tempDiv.innerText || '';

        // Then return the decoded string (which should now be proper HTML)
        return decodedString;
    };

    return (
        <CommonContainer heading="Notifications Master" buttonText="Add Notification" onButtonClick={() => { reset(); setAddNotificationModal(true); }}>
            <div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                    </div>
                    <div className="search-box" style={{ position: "relative", width: "320px" }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by Title, Criteria"
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                            style={{
                                paddingRight: "35px",
                                borderRadius: "5px",
                                border: "1px solid #ddd",
                            }}
                        />
                        <button
                            type="button"
                            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
                            style={{
                                padding: '5px',
                                position: "absolute",
                                right: "0px",
                                height: "35px",
                                width: "45px",
                                top: "50%",
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                                transform: "translateY(-50%)",
                            }}
                            onClick={() => handleSearch(searchTerm)}
                        >
                            <FaSearch />
                        </button>
                    </div>
                </div>
                <div className="table-responsive" >
                    <table className="table table-bordered custom-table" >
                        <thead>
                            <tr>
                                {/* <th> S. No </th> */}
                                <th style={{ width: '20%' }}> Title </th>
                                {/* <th style={{ width: '27%' }}> Description </th> */}
                                <th style={{ width: '10%' }}> Criteria </th>
                                <th style={{ width: '9%' }}> Start Date </th>
                                <th style={{ width: '9%' }}> End Date </th>
                                <th style={{ width: '6%' }}> For All </th>
                                <th style={{ width: '6%' }}> Pop Up </th>
                                <th style={{ width: '7%' }}> Marquee </th>
                                <th style={{ width: '6%' }}> Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                currentNotifications.length > 0 ? (
                                    currentNotifications.map((rec, index) => (
                                        <tr key={index}>
                                            <td>{rec?.Title}</td>
                                            {/* <td>{rec?.Description}</td> */}
                                            <td>{rec?.Notification_Creteria}</td>
                                            <td>{rec?.Start_Date && formatDate(rec.Start_Date)}</td>
                                            <td>{rec?.End_Date && formatDate(rec.End_Date)}</td>
                                            <td>
                                                {rec.Is_For_All ? <FaCheckCircle color="green" /> : <FaTimesCircle color="red" />}
                                            </td>
                                            <td>
                                                {rec.Is_Popup_Notification ? <FaCheckCircle color="green" /> : <FaTimesCircle color="red" />}
                                            </td>
                                            <td>
                                                {rec.Is_Marquee_Notification ? <FaCheckCircle color="green" /> : <FaTimesCircle color="red" />}
                                            </td>
                                            <td>
                                                <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewNotification_byId(rec.Id)} title="Edit CaseOrigin" />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="9" className="text-center">No Data found</td></tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {filteredNotificationList.length > itemsPerPage ? (
                    <CommonPagination
                        pageList={filteredNotificationList}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        setCurrentPage={setCurrentPage}
                    />
                ) : null}
            </div>

            {addNotificationModal && (
                <div className="modal-backdrop">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg custom-modal" style={{ maxWidth: '700px' }} role="document">
                            <div className="modal-content mb-0 p-0">
                                <div className="modal-header p-2-5">
                                    <h5 className="modal-title">{selectedNotification?.Title ? "Edit Notification" : "New Notification"}</h5>
                                    <button type="button" className="btn-close" onClick={handleModalClose}></button>
                                </div>
                                <div className="modal-body p-1">
                                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                        <div className="container" style={{ fontSize: "13px" }}>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className="fw-bold required mb-0-5">Title</label>
                                                    <input type="text" className="form-control" placeholder="Enter Title" {...register("Title", { required: "Title is required" })} defaultValue={selectedNotification?.Title ? selectedNotification.Title : null} />
                                                    {errors.Title && <p className="text-danger required_error">{errors.Title.message}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="fw-bold required mb-0-5">Notification Criteria</label>
                                                    <input type="text" className="form-control" placeholder="Enter Notification Criteria" {...register("Notification_Creteria", { required: "Notification Creteria is required" })} defaultValue={selectedNotification?.Notification_Creteria ? selectedNotification.Notification_Creteria : null} />
                                                    {errors.Notification_Creteria && <p className="text-danger required_error">{errors.Notification_Creteria.message}</p>}

                                                </div>

                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className="fw-bold required mb-0-5">Start Date</label>
                                                    <Controller
                                                        name="Start_Date"
                                                        control={control}
                                                        rules={{ required: 'Start date is required' }}
                                                        defaultValue={
                                                            selectedNotification?.Start_Date
                                                                ? new Date(selectedNotification.Start_Date)
                                                                : null
                                                        }
                                                        render={({ field, fieldState }) => (
                                                            <div className="position-relative mb-2">
                                                                <div className="position-relative">
                                                                    <ReactDatePicker
                                                                        {...field}
                                                                        selected={field.value}
                                                                        onChange={(date) => field.onChange(date)}
                                                                        className="form-control custom-notificationinput pe-5"  // add padding-end so icon doesn’t overlap text
                                                                        dateFormat="dd-MM-yyyy"
                                                                        placeholderText="Select Start Date"
                                                                        ref={(r) => {
                                                                            field.ref(r); // connect to RHF
                                                                            startDateRef.current = r; // your manual ref
                                                                        }}
                                                                    />
                                                                    <Calendar
                                                                        size={20}
                                                                        className="position-absolute"
                                                                        style={{
                                                                            right: '10px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            cursor: 'pointer',
                                                                            pointerEvents: 'auto'
                                                                        }}
                                                                        onClick={() => startDateRef.current?.setFocus()}
                                                                    />
                                                                </div>
                                                                {fieldState.error && (
                                                                    <div className="invalid-feedback d-block">
                                                                        {fieldState.error.message}
                                                                    </div>
                                                                )}
                                                            </div>

                                                        )}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="fw-bold required mb-0-5">End Date</label>
                                                    <Controller
                                                        name="End_Date"
                                                        control={control}
                                                        rules={{ required: 'End date is required' }}
                                                        defaultValue={
                                                            selectedNotification?.End_Date
                                                                ? new Date(selectedNotification.End_Date)
                                                                : null
                                                        }
                                                        render={({ field, fieldState }) => (
                                                            <div className="mb-2">
                                                                <div className="position-relative">
                                                                    <ReactDatePicker
                                                                        {...field}
                                                                        selected={field.value}
                                                                        onChange={(date) => field.onChange(date)}
                                                                        className="form-control custom-notificationinput pe-5"
                                                                        dateFormat="dd-MM-yyyy"
                                                                        placeholderText="Select End Date"
                                                                        ref={(r) => {
                                                                            field.ref(r); // connect to RHF
                                                                            endDateRef.current = r; // your manual ref
                                                                        }}
                                                                    />
                                                                    <Calendar
                                                                        size={20}
                                                                        className="position-absolute"
                                                                        style={{
                                                                            right: '10px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            cursor: 'pointer',
                                                                            pointerEvents: 'auto'
                                                                        }}
                                                                        onClick={() => endDateRef.current?.setFocus()}
                                                                    />
                                                                </div>
                                                                {fieldState.error && (
                                                                    <div className="invalid-feedback d-block">
                                                                        {fieldState.error.message}
                                                                    </div>
                                                                )}
                                                            </div>

                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className="fw-bold mb-0-5 required">Partner</label>
                                                    <Controller
                                                        name="partners"
                                                        control={control}
                                                        rules={{
                                                            required: !isForAll ? 'Please select at least one partner.' : false
                                                        }}
                                                        render={({ field }) => (
                                                            <>
                                                                <MultiSelect
                                                                    options={partnerList}
                                                                    displayValue="Partner_Display"
                                                                    selectedValues={isForAll ? [] : (field.value || [])}
                                                                    onSelect={!isForAll ? (selectedList, selectedItem) => {
                                                                        field?.onChange(selectedList);
                                                                        handlePartnerSelect(selectedItem);
                                                                    } : () => { }}
                                                                    onRemove={!isForAll ? (selectedList, removedItem) => {
                                                                        field.onChange(selectedList);
                                                                        handlePartnerRemove(removedItem);
                                                                    } : () => { }}
                                                                    placeholder={isForAll ? "All partner will be notified" : "Select Partner"}
                                                                    className={`${errors.partners ? 'is-invalid' : ''}`}
                                                                    disable={isForAll}
                                                                    // Additional styling for disabled state
                                                                    style={{
                                                                        pointerEvents: isForAll ? 'none' : 'auto',
                                                                        backgroundColor: isForAll ? '#f8f9fa' : 'white'
                                                                    }}
                                                                />
                                                                {errors.partners && !isForAll && (
                                                                    <div className="invalid-feedback d-block">
                                                                        {errors.partners.message}
                                                                    </div>
                                                                )}
                                                                {isForAll && (
                                                                    <div className="text-muted mt-1">
                                                                        <small>All partners will receive this notification</small>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    />
                                                </div>

                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className="fw-bold mb-0-5 required" htmlFor="description">Description</label>
                                                    {/* <Controller
                                                        name="Description"
                                                        control={control}
                                                        rules={{
                                                            required: 'Description is required',
                                                            validate: (value) => {
                                                                const textContent = value.replace(/<[^>]*>/g, '').trim();
                                                                if (textContent.length === 0) {
                                                                    return 'Description cannot be empty';
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        defaultValue={
                                                            selectedNotification?.Description
                                                                ? selectedNotification?.Description
                                                                : null
                                                        }
                                                        render={({ field }) => (
                                                            <ReactQuill
                                                                theme="snow"
                                                                value={field.value}
                                                                onChange={field.onChange}
                                                                modules={modules}
                                                                formats={formats}
                                                                placeholder="Enter description..."
                                                                style={{ height: '200px', marginBottom: '50px' }}
                                                            />
                                                        )}
                                                    /> */}
                                                    <div>
                                                        {/* Tab Navigation */}
                                                        <ul className="nav nav-tabs mb-3">
                                                            <li className="nav-item">
                                                                <button
                                                                    type="button"
                                                                    className={`nav-link ${activeTab === 'editor' ? 'active' : ''}`}
                                                                    onClick={() => setActiveTab('editor')}
                                                                >
                                                                    Rich Text Editor
                                                                </button>
                                                            </li>
                                                            {/* <li className="nav-item">
                                                                <button
                                                                    type="button"
                                                                    className={`nav-link ${activeTab === 'html' ? 'active' : ''}`}
                                                                    onClick={() => setActiveTab('html')}
                                                                >
                                                                    HTML Source
                                                                </button>
                                                            </li> */}
                                                            <li className="nav-item">
                                                                <button
                                                                    type="button"
                                                                    className={`nav-link ${activeTab === 'preview' ? 'active' : ''}`}
                                                                    onClick={() => setActiveTab('preview')}
                                                                >
                                                                    Preview
                                                                </button>
                                                            </li>
                                                        </ul>

                                                        <Controller
                                                            name="Description"
                                                            control={control}
                                                            rules={{
                                                                required: 'Description is required',
                                                                validate: (value) => {
                                                                    const textContent = value.replace(/<[^>]*>/g, '').trim();
                                                                    if (textContent.length === 0) {
                                                                        return 'Description cannot be empty';
                                                                    }
                                                                    return true;
                                                                }
                                                            }}
                                                            defaultValue={selectedNotification?.Description || ''}
                                                            render={({ field }) => (
                                                                <div className="tab-content">
                                                                    {activeTab === 'editor' && (
                                                                        <div className="tab-pane fade show active">
                                                                            <ReactQuill
                                                                                theme="snow"  // Important: specify the theme
                                                                                value={field.value || ''}
                                                                                onChange={field.onChange}
                                                                                modules={modules}
                                                                                formats={formats}
                                                                                placeholder="Enter description..."
                                                                                style={{ height: '200px', marginBottom: '50px' }}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {activeTab === 'html' && (
                                                                        <div className="tab-pane fade show active">
                                                                            <textarea
                                                                                value={field.value || ''}
                                                                                onChange={(e) => field.onChange(e.target.value)}
                                                                                placeholder="Enter HTML..."
                                                                                className="form-control"
                                                                                style={{
                                                                                    height: '250px',
                                                                                    fontFamily: 'monospace',
                                                                                    fontSize: '14px'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {activeTab === 'preview' && (
                                                                        <div className="tab-pane fade show active">
                                                                            <div
                                                                                className="border p-3 bg-light"
                                                                                style={{ minHeight: '250px' }}
                                                                                dangerouslySetInnerHTML={{ __html: decodeHTML(field.value) || '' }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12 d-flex flex-row gap-2">
                                                    <label className="fw-bold mb-0-5">&nbsp;</label>
                                                    <div className="form-check mr-2">
                                                        <input type="checkbox" id="forall" className="form-check-input" {...register("Is_For_All")} defaultChecked={selectedNotification?.Is_For_All ? selectedNotification?.Is_For_All : false} />
                                                        <label htmlFor="forall" className="form-check-label fw-bold">Is Notification for all</label>
                                                    </div>
                                                    <div className="form-check mr-2">
                                                        <input type="checkbox" id="is_marquee_notification" className="form-check-input" {...register("Is_Marquee_Notification")} defaultChecked={selectedNotification?.Is_Marquee_Notification ? selectedNotification?.Is_Marquee_Notification : false} />
                                                        <label htmlFor="is_marquee_notification" className="form-check-label fw-bold">Is Marquee</label>
                                                    </div>
                                                    <div className="form-check mr-2">
                                                        <input type="checkbox" id="pop-up" className="form-check-input" {...register("Is_Popup_Notification")} defaultChecked={selectedNotification?.Is_Popup_Notification ? selectedNotification?.Is_Popup_Notification : false} />
                                                        <label htmlFor="pop-up" className="form-check-label fw-bold">Is Popup</label>
                                                    </div>
                                                </div>
                                                <div>
                                                    {errors.notification_check && (
                                                        <div className="text-danger">{errors.notification_check.message}</div>
                                                    )}
                                                </div>
                                            </div>
                                            {/* <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className="fw-bold mb-0-5">Upload Image:</label>
                                                    <input className="form-control" style={{ width: '100%' }} type="file"
                                                        ref={fileInputRef}
                                                        accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
                                                        {...register("Document_File")}
                                                        onChange={handleMainFileUpload}
                                                    />
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <div className="alert alert-info p-2 mt-1 pt-2" style={{ fontSize: '9px', maxWidth: '350px', marginBottom: '4px' }}>
                                                        <strong>Note:</strong> You can upload a maximum of 1 files(less than 5MB).<br />
                                                        Accepted file: <code>.pdf</code>, <code>.doc</code>, <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>, <code>.png</code>, <code>.gif</code>, <code>.webp</code>, <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: "13px" }} >

                                                {/* {errors.Document_File && <p className="text-danger required_error">{errors.Document_File.message}</p>} */}

                                            </div>

                                            <ul className="list-group pl-3 pb-2 pt-1 col-md-6" >

                                            </ul>
                                        </div>

                                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                                            <button type="button" className="btn btn-danger" onClick={handleModalClose}>Close</button>
                                            <button type="submit" className="btn btn-success">Save</button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </CommonContainer>
    )
}

export default NotificationComponent